<template>
  <m-base
    :title="params.title"
    :subTitle="params.subTitle"
    :showMore="params.showMore"
    :icon="params.icon"
    :boxType="pattern.boxType"
    :showHeader="true"
    :showPadding="false"
    :showBorderRadius="pattern.showBorderRadius"
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showTopPadding="pattern.showTopPadding"
    :showRightPadding="pattern.showRightPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showLeftPadding="pattern.showLeftPadding"
    :backgroundColor="pattern.backgroundColor"
    :showIcon="params.showIcon"
    @onClickMore="navToDetailPage"
  />
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          title: '热销商品',
          subTitle: 'Hot Sales',
          showMore: true,
          icon: '/static/temp/h1.png',
          showIcon: true
        }
      }
    },
    data: {
      type: Object,
      default: () => {
        return {
          name: '商品分类',
          navTo: '/pages/category/category'
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          boxType: 'block',
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showTopPadding: true,
          showRightPadding: true,
          showBottomPadding: true,
          showLeftPadding: true,
          backgroundColor: 'rgba(255,255,255,1)',
          showBorderRadius: false,
        }
      }
    },
  },
  data () {
    return {
      myData: this.data
    };
  },
  created () {
  },
  methods: {
    navToDetailPage () {
      if (this.myData) {
        let navTo = this.myData.navTo
        if (this.myData.navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal) {
        this.myData = newVal;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
